import {
  Row,
  Col,
  Tree,
  Modal,
  Table,
  Tooltip,
  Tabs,
  Select,
  Menu,
  Button,
  Spin,
  Input,
  Form
} from "antd";
const TabPane = Tabs.TabPane;
import WeaFormItem from "../../wea-form-item";
import isEmpty from "lodash/isEmpty";
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import WeaTools from "../../wea-tools";
import WeaSearchBrowserBox from "../wea-search-browser-box";
import forEach from "lodash/forEach";
import WeaBrowserSingleList from "../wea-browser-single-list";
import WeaBrowserSingleTree from "../wea-browser-single-tree";
import WeaAssociativeSearch from "../wea-associative-search";
import WeaSelect from "../../wea-select";
import WeaBrowserSearch from "../../wea-browser-search";
import WeaLocaleProvider from "../../wea-locale-provider";
import WeaAlertPage from "../../wea-alert-page";
const getLabel = WeaLocaleProvider.getLabel;

class Main extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: true,
      showDrop: false,
      id: "",
      name: "",
      idCache: "",
      nameCache: "",
      dataKey: "", //sessionkey
      contentType: "",
      noPgTableData: {},
      browserConditions: [],
      showSearchAd: false,
      selectedValue: "",
      inputValue: "",
      count: 0,
      quickSearch: props.quickSearchName || "",
      treeDatas: [],
      defaultExpandedKeys: [],
      pageSize: props.pageSize || 20,
      loadAllTreeData: false,
      noData: false,
      dataIcon: "",
      dataIconBgColor: "",
      dataIconFontColor: "",
      urlOfIframeInDialogParrentHeight: "100%",
      urlOfIframeInDialog: ""
    };
  }
  componentDidMount() {
    const { value, valueSpan } = this.props;
    if (!isEmpty(value) && valueSpan) {
      this.setState({ id: value, name: valueSpan });
    }
    // 默认显示数据
    if (!isEmpty(this.props.replaceDatas) && this.props.replaceDatas[0]) {
      let name = this.props.replaceDatas[0].name;
      let id = this.props.replaceDatas[0].id + "";
      this.setState({ id: id, name: name });
      this.setState({ idCache: id, nameCache: name });
      // this.throwCurrentState(id, name);
    }
    this.props.initFunc && this.props.initFunc(this);
  }
  componentWillReceiveProps(nextProps, nextState) {
    if ("value" in nextProps) {
      if (nextProps.value) {
        let name = "";
        if (!isEmpty(nextProps.replaceDatas) && nextProps.replaceDatas[0]) {
          name =
            nextProps.replaceDatas[0].orgWholePathspan ||
            nextProps.replaceDatas[0].name;
        }
        this.setState({
          id: nextProps.value,
          name: nextProps.valueSpan || name
        });
      } else {
        this.setState({ id: "", name: "" });
        this.refs.associativeSearch && this.refs.associativeSearch.forceClear();
      }
    }
    if ("visible" in nextProps && this.setState.visible !== nextProps.visible) {
      //form value改变&&有值
      this.setState({ visible: nextProps.visible });
    }
    if (
      "replaceDatas" in nextProps &&
      !isEqual(this.props.replaceDatas, nextProps.replaceDatas) &&
      !nextProps.replaceNotCtrl
    ) {
      let id = "",
        name = "";
      if (!isEmpty(nextProps.replaceDatas) && nextProps.replaceDatas[0]) {
        name =
          nextProps.replaceDatas[0].orgWholePathspan ||
          nextProps.replaceDatas[0].name;
        id = nextProps.replaceDatas[0].id + "";
      } else {
        this.refs.associativeSearch && this.refs.associativeSearch.forceClear();
      }
      this.setState({ id: id, name: name });
      this.setState({ idCache: id, nameCache: name });
    }
  }
  set(datas) {
    let id = "",
      name = "";
    if (!isEmpty(datas)) {
      name = datas[0].name;
      id = datas[0].id;
    } else {
    }
    this.setState({ id: id, name: name });
  }
  // shouldComponentUpdate(nextProps,nextState) {
  //     return this.state.visible !== nextState.visible
  //     || this.state.loading !== nextState.loading
  //     || this.state.showDrop !== nextState.showDrop
  //     || this.state.id !== nextState.id
  //     || this.state.name !== nextState.name
  //     || this.state.idCache !== nextState.idCache
  //     || this.state.nameCache !== nextState.nameCache
  //     || (this.state.dataKey!==nextState.dataKey&&!isEmpty(this.state.dataKey)&&!isEmpty(nextState.dataKey))
  //     || this.state.contentType !== nextState.contentType
  //     || this.state.noPgTableData !== nextState.noPgTableData
  //     || this.state.browserConditions !== nextState.browserConditions
  //     || this.state.showSearchAd !== nextState.showSearchAd
  //     || this.state.selectedValue !== nextState.selectedValue
  //     || this.state.inputValue !== nextState.inputValue
  //     || this.state.url !== nextState.url
  //     || this.state.activeKey !== nextState.activeKey
  //     || this.state.count !== nextState.count
  //     || this.state.loadAllTreeData !== nextState.loadAllTreeData
  //     || !isEqual(this.state.treeDatas, nextState.treeDatas)
  //     || !isEqual(this.props.replaceDatas, nextProps.replaceDatas)
  //     || !isEqual(this.state.hasPgTableData, nextState.hasPgTableData)
  //     || this.props.type !== nextProps.type
  //     || this.props.visible !== nextProps.visible
  //     || this.props.viewAttr !== nextProps.viewAttr
  //     || this.props.fieldName !== nextProps.fieldName
  //     || this.props.title !== nextProps.title
  //     || this.props.tabs !== nextProps.tabs
  //     || this.props.form !== nextProps.form
  // }
  setLoading(bool) {
    this.setState({ loading: bool });
  }
  initialState = (params = {}) => {
    // this.props.form && this.props.form.resetFields();
    this.fetchData(this.getUrl(), params);
  };
  fetchData(url = "", param = {}, cb) {
    const { dataUrl, type, topPrefix } = this.props;
    const { pageSize } = this.state;
    url = url ? url : dataUrl;
    param["min"] = 1;
    param["max"] = 1 * pageSize;
    param["pageSize"] = pageSize;
    url = `${url}${WeaTools.getFd(param)}`;
    this.setState({ url });
    this.setLoading(true);
    WeaTools.callApi(url)
      .then(data => {
        if (cb) cb(data);
        if (data.datas && data.datas.length === 0) {
          this.setState({ noData: true });
        } else {
          this.setState({ noData: false });
        }
        if (data.iconSetting) {
          let dataIcon = "";
          let dataIconBgColor = "";
          let dataIconFontColor = "";
          if (data.iconSetting.icon) {
            dataIcon = data.iconSetting.icon;
          }
          if (data.iconSetting.bgColor) {
            dataIconBgColor = data.iconSetting.bgColor;
          }
          if (data.iconSetting.fontColor) {
            dataIconFontColor = data.iconSetting.fontColor;
          }
          this.setState({ dataIcon, dataIconBgColor, dataIconFontColor });
        }
        if (data.type == 1) {
          //datakeyHasPgTable
          this.setState({
            dataKey: data.datas,
            contentType: "dk_hasPgTable"
            // pageSize: data.pageSize || 20
          });
        }
        if (data.type == 2) {
          //nodatakeyNoPgTable
          this.setState({
            noPgTableData: { columns: data.columns, datas: data.datas },
            contentType: "noPgTable"
          });
          this.setLoading(false);
        }
        if (data.type == 3) {
          //Tree
          let defaultExpandedKeys = [];
          if (data.datas && data.datas.id) {
            defaultExpandedKeys.push(`${topPrefix}0-${data.datas.id}`);
          }
          if (!isEmpty(data.datas)) {
            this.setState({
              contentType: "Tree",
              treeDatas: data.datas,
              defaultExpandedKeys: defaultExpandedKeys,
              loadAllTreeData: data.isLoadAll
            });
          } else {
            this.setState({
              contentType: ""
            });
          }
          this.setLoading(false);
        }
        if (data.type == 4) {
          //nodatakeyHasPgTable
          this.setState({
            hasPgTableData: {
              columns: data.columns,
              datas: data.datas,
              count: data.total
            },
            contentType: "hasPgTable"
          });
          this.setLoading(false);
        }
        if (data.type == 5) {
          this.setState({
            urlOfIframeInDialog: data.datas.pcurl
          });
        }
      })
      .catch(e => this.props.onError && this.props.onError(e));
  }
  showModal = bool => {
    this.setState({ visible: bool });
    if (bool) {
      this.props.onOpen && this.props.onOpen();
    } else {
      this.props.onClose && this.props.onClose();
    }
  };
  handleOk = () => {
    const { idCache, nameCache } = this.state;
    this.setState(
      {
        id: idCache,
        name: nameCache,
        visible: false,
        showSearchAd: false,
        url: "",
        selectedValue: "",
        contentType: ""
      },
      () => {
        this.throwCurrentState(idCache, nameCache, this.dataCache);
      }
    );
    // const {resetFields} = this.props.form;
    // resetFields(); // 重置高级搜索
    this.showModal(false);
  };
  handleCancel = () => {
    // const {resetFields} = this.props.form;
    // resetFields(); // 重置高级搜索
    this.setState({
      showSearchAd: false,
      idCache: "",
      nameCache: "",
      url: "",
      selectedValue: "",
      contentType: ""
    });
    this.showModal(false);
  };
  handleClear = () => {
    // const {resetFields} = this.props.form;
    // resetFields(); // 重置高级搜索
    this.throwCurrentState("", "");
    this.setState({
      selectedValue: "",
      idCache: "",
      nameCache: "",
      showSearchAd: false,
      url: "",
      contentType: ""
    });
    this.showModal(false);
    this.refs.associativeSearch && this.refs.associativeSearch.forceClear();
  };
  onCustomClick = e => {
    e && e.preventDefault();
    if (this.props.onBeforeFocusCheck) {
      let cb = this.onCustomClickInner.bind(this);
      this.props.onBeforeFocusCheck(cb);
    } else {
      this.onCustomClickInner(e);
    }
  };
  onCustomClickInner = e => {
    const { memorise } = this.props;
    if (memorise) {
      const { id, name } = this.state;
      this.onBrowerClick([{ id: id, name: name }]);
    } else {
      this.onBrowerClick();
    }
  };
  getConditionDataParamsUrl(activeKey) {
    let url = "";
    const { tabs, conditionURL } = this.props;
    let tab = {};
    if (!isEmpty(tabs)) {
      tab = tabs.filter(m => m.key == activeKey)[0];
    }
    if (tab && !isEmpty(tab.conditionDataParams)) {
      url = `${conditionURL}${WeaTools.getFd(tab.conditionDataParams)}&`;
    }
    return url;
  }
  getConditions(conditionURL, cb) {
    WeaTools.callApi(conditionURL).then(data => {
      let quickSearch = "";
      if (!isEmpty(data.conditions)) {
        data.conditions.forEach(item => {
          if (item.isQuickSearch) {
            quickSearch = item.domkey[0];
          }
        });
      }
      const params = WeaTools.getParamsByConditions(data.conditions);
      cb && cb(params);

      this.browserConditionsBk = data.conditions;
      this.defaultConditionParams = { ...params };
      const { setFieldsValue, resetFields } = this.props.form;
      resetFields();
      if (!isEmpty(params)) {
        // 初始条件更新在form中
        setFieldsValue(params);
        conditionParamsBK = { ...params };
      }
      this.setState({
        browserConditions: data.conditions,
        inputValue: params[quickSearch] || "",
        selectedValue: params["date2during"] || "",
        showSearchAd: false,
        quickSearch
      });
    });
  }
  getDefaultActiveKey() {
    let activeKey = "1";
    const { tabs } = this.props;
    if (Array.isArray(tabs) && !isEmpty(tabs)) {
      let t = tabs[0];
      tabs.forEach(tab => {
        if (tab.selected) {
          t = tab;
        }
      });
      return t.key;
    }
    return activeKey;
  }
  onBrowerClick = v => {
    if (this.props.onBrowerClick) {
      this.props.onBrowerClick(v, () => {
        this.onBrowerClickInner(v);
      });
    } else {
      this.onBrowerClickInner(v);
    }
  };
  onBrowerClickInner = v => {
    const { conditionURL, hasAdvanceSerach } = this.props;
    this.setState(
      {
        browserConditions: [],
        inputValue: "",
        activeKey: this.getDefaultActiveKey()
      },
      () => {
        if (hasAdvanceSerach) {
          // 获取高级搜索 condition
          this.getConditions(conditionURL, params => {
            this.initialState(params); //初始化浏览框
          });
        } else {
          this.initialState(); //初始化浏览框
          this.setState({ inputValue: "" });
        }
        if (!isEmpty(v)) {
          this.setState({ idCache: v[0].id, nameCache: v[0].name });
          this.dataCache = v;
        } else {
          this.setState({ id: "", name: "", idCache: "", nameCache: "" });
          this.dataCache = null;
        }
      }
    );

    this.showModal(true);
  };
  onBrowerChangeHandler = (id, name, data) => {
    this.throwCurrentState(id, name, data);
  };
  renderList(hasPagination, contentType) {
    const { hasRadio } = this.props;
    const {
      browserConditions,
      dataKey,
      noPgTableData,
      hasPgTableData,
      pageSize
    } = this.state;
    const tableConfig = () => {
      if (hasPagination && contentType == "dk_hasPgTable") {
        return { dataKey: dataKey };
      }
      if (hasPagination && contentType == "hasPgTable") {
        return { hasPgTableData: hasPgTableData };
      }
      if (!hasPagination && contentType == "noPgTable") {
        return { noPgTableData: noPgTableData };
      }
    };
    return (
      <WeaBrowserSingleList
        {...tableConfig()}
        hasRadio={hasRadio}
        pageSize={pageSize}
        url={this.state.url}
        contentType={contentType}
        hasPagination={hasPagination}
        getSelection={this.onTableCheck.bind(this)}
        setData={this.setListData.bind(this)}
        setLoading={this.setLoading.bind(this)}
        {...this.props}
      />
    );
  }
  onTableCheck(keys, datas) {
    this.setState({ idCache: keys[0] });
    this.throwCurrentState(keys[0]);
  }
  closeModal() {
    this.setState({ visible: false });
  }
  openModal() {
    this.onCustomClick();
  }
  get() {
    return {
      id: this.state.idCache,
      name: this.state.nameCache
    };
  }
  reload() {
    this.onBrowerClick();
  }
  onSearchChange = v => {
    const { props } = this;
    this.setState({ inputValue: v });
    const { form } = props;
    const { quickSearch, selectedValue } = this.state;
    const { setFieldsValue } = form;
    let params = {};
    let fieldNames = [];
    const formParams = {};
    let formFields = form.getFields() || [];
    for (const key in formFields) {
      if (formFields.hasOwnProperty(key)) {
        fieldNames.push(key);
      }
    }
    const newObject = cloneDeep(form.getFieldsValue(fieldNames));
    Object.keys(newObject).forEach(key => {
      const value = newObject[key];
      if (value || value === 0 || value === false) formParams[key] = value;
    });
    params = { ...formParams };
    params[quickSearch] = v;
    if (props.sap) params.issearch = true;
    if (selectedValue) params["date2during"] = selectedValue;
    setFieldsValue(params); // 高级搜索数据联动
    let url = this.getUrl(true);
    this.fetchData(url, params);
  };
  search = e => {
    const { props } = this;
    const { quickSearch } = this.state;
    e.preventDefault();
    const { form } = props;
    let params = {};
    let fieldNames = [];
    const formParams = {};
    let formFields = form.getFields() || [];
    for (const key in formFields) {
      if (formFields.hasOwnProperty(key)) {
        fieldNames.push(key);
      }
    }
    const newObject = cloneDeep(form.getFieldsValue(fieldNames));
    Object.keys(newObject).forEach(key => {
      const value = newObject[key];
      if (value || value === 0 || value === false) formParams[key] = value;
    });
    params = { ...formParams };
    let url = this.getUrl(true);
    if (props.sap) params.issearch = true;
    this.fetchData(url, params, data => {
      if (
        window.browserSearchHandler &&
        typeof window.browserSearchHandler === "function"
      ) {
        window.browserSearchHandler(data, params, url);
      }
    });
    this.setState({
      showSearchAd: false,
      inputValue: params[quickSearch] || ""
    });
    if (params["date2during"]) {
      this.setState({ selectedValue: params["date2during"] });
    }
  };
  getFields() {
    const { validateFields } = this.props.form;
    let params = {};
    validateFields((errors, object) => {
      if (!!errors) {
        return;
      }
      let newObject = cloneDeep({ ...object, ...conditionParamsBK });
      forEach(newObject, (value, key) => {
        if (value || value === 0 || value === false) params[key] = value;
      });
    });
    return params;
  }
  focus() {
    this.refs.associativeSearch.focus();
  }
  renderTree(hasPagination) {
    const { type, hideVirtualOrg } = this.props;
    const {
      idCache,
      nameCache,
      url,
      treeDatas,
      defaultExpandedKeys,
      loadAllTreeData
    } = this.state;
    let showDropMenu = type == "4" || type == "164";
    if (hideVirtualOrg) showDropMenu = false;
    return (
      <WeaBrowserSingleTree
        {...this.props}
        url={url}
        id={idCache}
        name={nameCache}
        treeDatas={treeDatas}
        defaultExpandedKeys={defaultExpandedKeys}
        showDropMenu={showDropMenu}
        setData={this.setTreeData.bind(this)}
        isLoadAll={loadAllTreeData}
      />
    );
  }
  getUrl(searched = false, activeKey) {
    activeKey = activeKey || this.state.activeKey;
    const { tabs, dataUrl } = this.props;
    let url = dataUrl;
    let tab = {};
    if (!isEmpty(tabs)) {
      tab = tabs.filter(m => m.key == activeKey)[0];
    }
    if (searched && !isEmpty(tabs)) {
      tabs.forEach(t => {
        if (t.isSearch) {
          tab = t;
          this.setState({ activeKey: t.key });
        }
      });
    }
    if (tab && tab.url) {
      url = `${tab.url}?`;
    }
    if (tab && !isEmpty(tab.dataParams)) {
      url = `${url}${WeaTools.getFd(tab.dataParams)}&`;
    }
    return url;
  }
  onTabsChange = activeKey => {
    const { resetFields, setFieldsValue } = this.props.form;
    const { hasAdvanceSerach } = this.props;
    this.setState({ browserConditions: [] });
    resetFields();
    const url = this.getUrl(false, activeKey);
    if (hasAdvanceSerach) {
      let conditionURL = this.getConditionDataParamsUrl(activeKey);
      if (conditionURL) {
        this.getConditions(conditionURL, params => {
          this.fetchData(url, params);
        });
      } else {
        this.fetchData(url, this.defaultConditionParams);
        const quickSearch = this.state.quickSearch;
        this.setState({
          browserConditions: this.browserConditionsBk
        });
        if (!isEmpty(this.defaultConditionParams)) {
          conditionParamsBK = { ...this.defaultConditionParams };
          this.setState({
            inputValue: this.defaultConditionParams[quickSearch] || "",
            selectedValue: this.defaultConditionParams["date2during"] || ""
          });
        }
      }
      this.setState({
        url,
        activeKey,
        showSearchAd: false
      });
    } else {
      this.fetchData(url);
      this.setState({
        url,
        activeKey,
        inputValue: ""
      });
    }
  };
  renderTab() {
    const { tabs } = this.props;
    let TabPanes = [];
    if (!isEmpty(tabs)) {
      tabs.forEach(tab => {
        TabPanes.push(<TabPane tab={tab.name} key={tab.key} />);
      });
      return (
        <Tabs onChange={this.onTabsChange} activeKey={this.state.activeKey}>
          {TabPanes}
        </Tabs>
      );
    }
    return;
  }
  getSearchType() {
    let r = [];
    const { quickSearch } = this.state;
    const { hasAdvanceSerach } = this.props;
    if (quickSearch) {
      r.push("base");
    }
    if (hasAdvanceSerach) {
      r.push("advanced");
    }
    return r;
  }
  topComponents = () => {
    const {
      inputValue,
      showSearchAd,
      selectedValue,
      browserConditions,
      activeKey
    } = this.state;
    const { type, hasAdvanceSerach } = this.props;
    const { quickSearch } = this.state;
    const tab = this.renderTab();
    const showTop = tab || hasAdvanceSerach || quickSearch;
    const addSelect = () => {
      let options = [];
      let viewAttr = "2";
      if (type == "16") {
        browserConditions.forEach(m => {
          if (m.domkey[0] == "date2during") {
            options = m.options;
            if (m.viewAttr) viewAttr = m.viewAttr;
          }
        });
      }
      if (options.length > 0) {
        return (
          <WeaSelect
            viewAttr={viewAttr}
            style={{ width: "100px" }}
            value={selectedValue}
            options={options}
            onChange={this.doChangeEvent}
          />
        );
      }
    };
    if (showTop) {
      return (
        <WeaBrowserSearch
          buttonsAd={this.getTabButtonsAd()}
          addSelect={type == "16" ? addSelect() : ""}
          tabs={tab}
          searchType={this.getSearchType()}
          searchsBaseValue={inputValue}
          searchsAd={<Form horizontal>{this.getSearchs()}</Form>}
          showSearchAd={showSearchAd}
          setShowSearchAd={bool => {
            this.setShowSearchAd(bool);
          }}
          onSearchChange={v => {
            this.setState({ inputValue: v });
          }}
          onSearch={this.onSearchChange.bind(this)}
        />
      );
    }
  };
  setShowSearchAd(bool) {
    const { showSearchAd } = this.state;
    this.setState({ showSearchAd: bool });
  }
  renderEmpty() {
    let param = {
      icon: <sapn className="icon-coms-NoData" />,
      iconSize: 40,
      minHeight: 432
    };
    return (
      <WeaAlertPage {...param}>
        <div style={{ color: "#000" }}>{getLabel("83553", "暂无数据")}</div>
      </WeaAlertPage>
    );
  }
  render() {
    const {
      icon,
      iconBgcolor = "",
      iconFontColor = "#fff",
      title,
      topPrefix,
      value,
      type,
      modalStyle,
      customized,
      hasRadio,
      buttons,
      noScroll = false,
      hasAdvanceSerach,
      urlOfIframeInDialogKey
    } = this.props;
    const {
      showDrop,
      listDatas,
      listColumns,
      id,
      name,
      visible,
      contentType,
      loading,
      urlOfIframeInDialog
    } = this.state;
    const {
      quickSearch,
      dataIcon,
      dataIconBgColor,
      dataIconFontColor
    } = this.state;
    const tab = this.renderTab();
    const showTop = tab || hasAdvanceSerach || quickSearch;
    const titleEle = (
      <Row>
        <Col span="22" style={{ paddingLeft: 20, lineHeight: "48px" }}>
          <div className="wea-browser-single-title">
            {dataIconBgColor || iconBgcolor ? (
              <div
                className="wea-browser-single-icon-circle"
                style={{
                  background: dataIconBgColor || iconBgcolor,
                  color: dataIconFontColor || iconFontColor
                }}
              >
                <i className={dataIcon || icon} />
              </div>
            ) : (
              <span style={{ verticalAlign: "middle", marginRight: 10 }}>
                <i className={icon} />
              </span>
            )}
            <span style={{ verticalAlign: "middle" }}>{title}</span>
          </div>
        </Col>
      </Row>
    );
    let inputArr = (
      <div className="ant-search-custom">
        <Input
          key="theInput"
          addonAfter={
            <div style={{ cursor: "pointer" }}>
              <i
                onClick={this.showModal.bind(this)}
                className="anticon anticon-search"
              />
            </div>
          }
          value={typeof value === "undefined" ? "" : name}
        />
      </div>
    );
    if (!!type) {
      inputArr = (
        <WeaAssociativeSearch
          {...this.props}
          ref="associativeSearch"
          style={this.props.inputStyle}
          type={type}
          value={value}
          ids={id}
          names={name}
          clickCallback={this.onBrowerClick}
          hasScroll={!noScroll}
          onChange={this.onBrowerChangeHandler}
        />
      );
    }
    let dom = inputArr;
    if (customized) {
      dom = (
        <div className="cursor-pointer" onClick={this.onCustomClick}>
          {this.props.children}
        </div>
      );
    }
    if (urlOfIframeInDialog) {
      return (
        <div>
          {dom}
          {this.props.extraElement}
          <input
            type="hidden"
            id={this.props.fieldName}
            name={this.props.fieldName}
            value={id}
          />
          <Modal
            wrapClassName={`wea-browser-single ${
              showTop ? "" : "no-top"
            } wea-browser-modal wea-browser-table-cursor wea-browser-iframe-in-dialog`}
            title={titleEle}
            zIndex={this.props.zIndex}
            width={modalStyle.width}
            // style={modalStyle}
            maskClosable={false}
            visible={visible}
            onCancel={this.handleCancel.bind(this)}
            footer={[]}
            {...this.props.browserModalProps}
          >
            <iframe
              key="iframe"
              ref={el => {
                if (
                  el &&
                  this.state.urlOfIframeInDialogParrentHeight === "100%"
                ) {
                  // 由于 modal 多次渲染，目前只能计算一次高度
                  const parrent = $(el).closest(".ant-modal-body");
                  if (parrent.length > 0 && parrent.height() > 0) {
                    const urlOfIframeInDialogParrentHeight = parrent.height();
                    if (urlOfIframeInDialogParrentHeight > 0) {
                      this.setState({ urlOfIframeInDialogParrentHeight });
                    }
                  }
                }
              }}
              style={{
                border: 0,
                width: "100%",
                height: this.state.urlOfIframeInDialogParrentHeight,
                minHeight: 400
              }}
              src={`${urlOfIframeInDialog}${
                /\?/.test(urlOfIframeInDialog) ? "&" : "?"
              }urlOfIframeInDialogKey=${urlOfIframeInDialogKey}`}
            />
          </Modal>
        </div>
      );
    }
    const hasPagination =
      contentType == "hasPgTable" || contentType == "dk_hasPgTable";
    const isList =
      contentType == "noPgTable" ||
      contentType == "hasPgTable" ||
      contentType == "dk_hasPgTable";
    const isTree = contentType == "Tree";
    let footer = buttons || [
      isTree && (
        <Button key="submit" type="primary" onClick={this.handleOk.bind(this)}>
          {getLabel(385565, "确 定")}
        </Button>
      ),
      <Button key="clear" type="ghost" onClick={this.handleClear.bind(this)}>
        {getLabel(385566, "清 除")}
      </Button>,
      <Button key="back" type="ghost" onClick={this.handleCancel.bind(this)}>
        {getLabel(385567, "取 消")}
      </Button>
    ];
    return (
      <div>
        {dom}
        {this.props.extraElement}
        <input
          type="hidden"
          id={this.props.fieldName}
          name={this.props.fieldName}
          value={id}
        />
        <Modal
          wrapClassName={`wea-browser-single ${
            showTop ? "" : "no-top"
          } wea-browser-modal wea-browser-table-cursor`}
          title={titleEle}
          zIndex={this.props.zIndex}
          width={modalStyle.width}
          // style={modalStyle}
          maskClosable={false}
          visible={visible}
          onCancel={this.handleCancel.bind(this)}
          footer={footer}
          {...this.props.browserModalProps}
        >
          {this.topComponents()}
          <Spin spinning={loading}>
            <div
              style={
                window.setDialogFullWindow
                  ? { minHeight: 400 }
                  : { minHeight: 423 }
              }
            >
              {/*<div style={{minHeight: 440}}>*/}
              {isList && this.renderList(hasPagination, contentType)}
              {isTree && this.state.noData && this.renderEmpty()}
              {isTree &&
                !this.state.noData &&
                this.renderTree(hasPagination, contentType)}
            </div>
          </Spin>
        </Modal>
      </div>
    );
  }
  resetFields() {
    const { resetFields, setFieldsValue } = this.props.form;
    const { browserConditions } = this.state;
    const fields = {};
    browserConditions.forEach(c => {
      let ct = c.conditionType.toUpperCase();
      let domkey = c.domkey[0];
      const filterKeys = [1, -1, "1", "-1"];
      if (ct === "BROWSER") {
        if (
          !isEmpty(c.browserConditionParam) &&
          filterKeys.indexOf(c.browserConditionParam.viewAttr) == -1
        ) {
          fields[domkey] = undefined;
          conditionParamsBK[domkey] = "";
        }
      } else if (ct === "SELECT") {
        let v = WeaTools.getSelectDefaultValue(c.options) || "";
        fields[domkey] = v;
        conditionParamsBK[domkey] = v;
      } else if (ct === "DATE") {
        let v = WeaTools.getValueByfield(c);
        if (v && v.value) {
          c.domkey.forEach((d, idx) => {
            fields[d] = v.value[idx];
            conditionParamsBK[d] = v.value[idx];
          });
        }
      } else if (ct === "SCOPE") {
        if (filterKeys.indexOf(c.viewAttr) == -1) {
          fields[domkey] = undefined;
          fields[c.domkey[1]] = undefined;
          conditionParamsBK[domkey] = "";
          conditionParamsBK[c.domkey[1]] = "";
        }
      } else {
        if (filterKeys.indexOf(c.viewAttr) == -1) {
          fields[domkey] = undefined;
          conditionParamsBK[domkey] = "";
        }
      }
    });
    setFieldsValue(fields);
  }
  doChangeEvent = v => {
    const { setFieldsValue } = this.props.form;
    const url = this.getUrl();
    let params = this.getFields();
    params.date2during = v;
    this.fetchData(url, params);
    this.setState({ selectedValue: v });
    setFieldsValue({ date2during: v });
  };
  getTabButtonsAd() {
    return [
      <Button type="primary" onClick={e => this.search(e)}>
        {getLabel(197, "搜索")}
      </Button>,
      <Button
        type="ghost"
        onClick={e => {
          this.reset();
        }}
      >
        {getLabel(2022, "重置")}
      </Button>,
      <Button
        type="ghost"
        onClick={() => {
          this.setState({ showSearchAd: false });
        }}
      >
        {getLabel(31129, "取消")}
      </Button>
    ];
  }
  reset() {
    this.resetFields();
    this.setState({ inputValue: "" });
  }
  getSearchs() {
    const { browserConditions } = this.state;
    let items = new Array();
    !!browserConditions &&
      browserConditions.forEach(field => {
        items.push({
          com: (
            <WeaFormItem
              label={`${field.label}`}
              labelCol={{ span: `${field.labelcol}` }}
              wrapperCol={{ span: `${field.fieldcol}` }}
              viewAttr={field.viewAttr}
            >
              {WeaTools.getComponent(
                field.conditionType,
                field.browserConditionParam,
                field.domkey,
                this.props,
                field
              )}
            </WeaFormItem>
          ),
          colSpan: field.colSpan || 2,
          hide: WeaTools.isComponentHide(field)
        });
      });
    return <WeaSearchBrowserBox items={items} />;
  }

  throwCurrentState(id = "", name, record) {
    const data = [];
    if (id || name) {
      data.push({
        id: id.toString(),
        name: name
      });
    }
    this.props.onChange &&
      this.props.onChange(id.toString(), name, record || data);
  }
  setListData(id, name, record) {
    if (this.props.hasRadio) return;
    if (this.props.checkHook) {
      if (this.props.checkHook(id, name, record)) {
        this.setState(
          {
            id,
            name
          },
          () => {
            this.throwCurrentState(id, name, record);
          }
        );
        this.showModal(false);
      }
    } else {
      if (!this.props.sap) {
        this.setState(
          {
            id,
            name
          },
          () => {
            this.throwCurrentState(id, name, record);
          }
        );
      } else {
        this.throwCurrentState(id, name, record);
      }
      this.showModal(false);
    }
  }
  setTreeData(id, name, data) {
    let dataTemp = { ...data[0] };
    if (this.props.type == "22") {
      name = data[0].prop.fullName || name;
      dataTemp.name = name;
    }
    this.setState({
      idCache: id,
      nameCache: name
    });
    this.dataCache = [dataTemp];
  }
}
let conditionParamsBK = {};
Main = Form.create({
  onFieldsChange(props, fields) {
    for (let key in fields) {
      conditionParamsBK[fields[key].name] = fields[key].value;
    }
  }
})(Main);
export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-browser-single/index.js